import { EduHubArticleResult } from 'types/studio/eduHub';
import { EduArticleCard } from './EduArticleCard';

interface Props {
  articles: EduHubArticleResult[];
  hasFeaturedArticle?: boolean;
}

export const EduArticleCards = ({ articles, hasFeaturedArticle = false }: Props) => {
  if (articles.length === 0) {
    return null;
  }

  return (
    <>
      {articles.map((card, index) => (
        <EduArticleCard
          key={card?.slug?.current}
          card={card}
          lazyLoadingImage={hasFeaturedArticle ? index > 1 : index > 5}
        />
      ))}
    </>
  );
};
